import Vue, { CreateElement } from '@src/vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import Checkup from '@src/data/checkup'
import { TableList } from '@src/components/table-list/table-list'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { Link } from '@src/elements/link/link'
import EventBus from '@src/lib/event_bus'
import { convertToLocalDate } from '@src/util/date-format'

import './list.sass'

@Component({
  computed: {
    checkupFilters () {
      return this.$store.state.checkups.checkupFilters
    }
  }
})
export class CheckupsList extends Vue {

  protected currentPage = 1

  @Prop({ required: true })
  private checkups: Checkup[]

  @Prop({ required: true })
  private cells: any

  private checkupFilters: string[]

  constructor () {
    super()
  }

  @Watch('checkupFilters')
  filtersChanged () {
    return this.changePage(1)
  }

  remove () {
    EventBus.trigger('reloadCheckups')
  }

  resetFilters () {
    this.$store.dispatch('filterCheckups', [])
  }

  filter (): Checkup[] {
    const filterByStatus = (checkup: Checkup) => {
      if (this.checkupFilters.length === 0) {
        return true
      }
      let tagFound = false
      this.checkupFilters.forEach(state => {
        if (checkup.state === state) {
          tagFound = true
        }
      })
      return !tagFound
    }

    return this.checkups.filter(elem => filterByStatus(elem))
  }

  changePage (page) {
    const scrollableEl = document.getElementsByClassName('component-tabs-body')[0] || document.getElementsByClassName('member-content')[0]
    scrollableEl.scrollTop = 0
    this.currentPage = page
  }

  render (h: CreateElement) {
    const checkups = this.filter()
      .map((checkup: Checkup) => {
        return {
          date: checkup.completedDate ? convertToLocalDate(checkup.completedDate) : convertToLocalDate(checkup.plannedDate),
          status: checkup.state,
          options: { checkup: checkup, removeCallback: this.remove }
        }
      })

    if (checkups.length === 0) {
      return <ErrorScreen message={this.$t('PAGE.MEMBERS.CHECKUPS.FILTER_ERROR')}>
        <Link variant='colored' ref='resetFilters' align='center' click={this.resetFilters} label={this.$t('PAGE.MEMBERS.CHECKUPS.RESET_FILTERS')} />
      </ErrorScreen>
    }

    return <TableList class='checkup-list' items={checkups.length ? checkups : /* istanbul ignore next: the empty list returns above */ []}
                      cells={this.cells}
                      header={{
                        date: { headerLabel: this.$t('DATE'), type: 'date' },
                        status: { headerLabel: this.$t('PAGE.MEMBERS.ACTIVITIES.STATUS.STATUS'), type: 'string' },
                        options: { headerLabel: '', type: 'html' }
                      }}
                      changePageCallback={this.changePage} currentPage={this.currentPage} />
  }
}
